// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes scaleInRight {
  from {
    transform: scaleX(0);
  }

  to {
    transform: scaleX(1);
  }
}

.scaleInRight {
  animation-name: scaleInRight;
  transform-origin: center left;
}`, "",{"version":3,"sources":["webpack://./resources/assets/js/scss/custom-animate/scale_entrances/scaleInRight.css"],"names":[],"mappings":"AAAA;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,oBAAoB;EACtB;AACF;;AAEA;EACE,4BAA4B;EAC5B,6BAA6B;AAC/B","sourcesContent":["@keyframes scaleInRight {\n  from {\n    transform: scaleX(0);\n  }\n\n  to {\n    transform: scaleX(1);\n  }\n}\n\n.scaleInRight {\n  animation-name: scaleInRight;\n  transform-origin: center left;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
